var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _path8, _path9, _circle2, _path10, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path11, _polygon, _rect13, _path12, _path13, _path14, _path15, _circle3, _circle4, _circle5, _path16, _circle6, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailArrived(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "f55c1cc7-a527-4cda-b37a-1ea88d078d90",
    width: 1034,
    height: 823.843,
    "data-name": "Layer 1",
    viewBox: "0 0 1034 823.843",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrived") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 775.703,
    cy: 59.262,
    r: 33.293,
    fill: "#2f2e41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9f616a",
    d: "M835.17577,117.65471s-4.81562,60.643-10.59435,60.643S892,175.44389,892,175.44389s-30.81992-39.953-15.41-52.795S835.17577,117.65471,835.17577,117.65471Z",
    transform: "translate(-83 -38.0783)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M835.17577,117.65471s-4.81562,60.643-10.59435,60.643S892,175.44389,892,175.44389s-30.81992-39.953-15.41-52.795S835.17577,117.65471,835.17577,117.65471Z",
    opacity: 0.1,
    transform: "translate(-83 -38.0783)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M700.5,814.96491a289.50131,289.50131,0,1,1,204.707-84.793A287.604,287.604,0,0,1,700.5,814.96491Zm0-576c-157.97656,0-286.5,128.52344-286.5,286.5s128.52344,286.5,286.5,286.5S987,683.44147,987,525.46491,858.47656,238.96491,700.5,238.96491Z",
    transform: "translate(-83 -38.0783)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M921.65272,250.33528,888,259.96491l47.00737-2.14408a41.39094,41.39094,0,0,1,29.02035,9.76445c8.375,7.25,15.125,18.75,8.625,35.75-13,34-33,66-33,66l-13,25s-27,4-28-4,0-12,5-16,8-12,8-16-1-8,2-10,4-5,4-11S935,304.96491,935,304.96491s-36.34728-12.62963-52-2-47.34728,57.37037-47.34728,57.37037a30.091,30.091,0,0,0-5.16716,7.34163,25.94983,25.94983,0,0,1-6.53689,8.12988c-2.90809,2.55551-.22985,9.59459.70405,10.52849,1,1,11,41,11,41s11,19-1,20-23,2-24,0a54.36233,54.36233,0,0,0-4-8c-3-5,0-16,0-16s-29-37-20-60,28-75,28-75l29-12,53-19Z",
    transform: "translate(-83 -38.0783)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "M719.65272,142.33528l-41-8s-10-34-22-30,8,38,8,38l57,26Z",
    transform: "translate(-83 -38.0783)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "M968.65272,176.33528l18,23s26-1,18,13-26,6-27,3-30-29-30-29Z",
    transform: "translate(-83 -38.0783)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M875,145.96491l-26,20-16-24-124-7v41c30.516-8.81131,58.60522-11.54094,81,0,28.3457,37.74438,34.5827,78.73141,16.65271,123.26291L953,247.96491c-43.86261-16.33332-64.2243-40.01193-58-72l51,18,31-23C949.27844,152.31093,908.02161,140.61144,875,145.96491Z",
    transform: "translate(-83 -38.0783)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 517,
    cy: 784.843,
    fill: "#3f3d56",
    rx: 517,
    ry: 39
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 372.5,
    cy: 783.843,
    opacity: 0.1,
    rx: 349.5,
    ry: 26
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M1018.16176,769.98374c-3.33123,29.19032,14.61428,55.2099,14.61428,55.2099s23.34649-21.30729,26.67772-50.49761-14.61427-55.2099-14.61427-55.2099S1021.493,740.79342,1018.16176,769.98374Z",
    transform: "translate(-83 -38.0783)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M1030.88856,768.47745c12.0073,26.81412,2.77581,57.04389,2.77581,57.04389s-28.69917-13.2445-40.70648-40.05861-2.77582-57.04389-2.77582-57.04389S1018.88125,741.66334,1030.88856,768.47745Z",
    transform: "translate(-83 -38.0783)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 625.559,
    cy: 671.249,
    r: 112.056,
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M708.55865,536.5729l-27.60473,69.01183-99.81872.80048-32.51837.26225-77.169.62112-32.50464.26225-77.169.62112-32.50455.26225-77.16908.63494-32.50455.26225-52.09012.41405L157.4302,589.1047l-13.07088-26.70763-7.21861-14.78228L133,536.5729l24.77526-78.4665a37.827,37.827,0,0,1,36.06559-26.43148h450.7576a37.83544,37.83544,0,0,1,35.6239,25.14787l2.87092,8.08817Z",
    transform: "translate(-83 -38.0783)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 575.559,
    height: 144.925,
    x: 50,
    y: 498.496,
    fill: "#6c63ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 575.559,
    height: 144.925,
    x: 50,
    y: 498.496,
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16.978,
    height: 16.978,
    x: 617.07,
    y: 299.428,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 16.978,
    height: 16.978,
    x: 662.911,
    y: 662.76,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 368.523,
    height: 463.759,
    x: 152.828,
    y: 311.473,
    fill: "#f2f2f2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 107.658,
    height: 15.183,
    x: 230.121,
    y: 344.598,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 324.356,
    height: 6.901,
    x: 173.531,
    y: 406.709,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 324.356,
    height: 6.901,
    x: 173.531,
    y: 428.793,
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 324.356,
    height: 6.901,
    x: 173.531,
    y: 450.876,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 324.356,
    height: 6.901,
    x: 173.531,
    y: 472.96,
    fill: "#e6e6e6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 324.356,
    height: 6.901,
    x: 173.531,
    y: 495.044,
    fill: "#e6e6e6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 324.356,
    height: 6.901,
    x: 173.531,
    y: 517.128,
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M270.33354,410.28126a23.464,23.464,0,1,1,23.464-23.464A23.49026,23.49026,0,0,1,270.33354,410.28126Zm0-44.16757a20.70355,20.70355,0,1,0,20.70355,20.70354A20.727,20.727,0,0,0,270.33354,366.11369Z",
    transform: "translate(-83 -38.0783)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3f3d56",
    points: "625.559 786.964 50 786.964 50 498.495 124.533 556.465 553.786 553.704 625.559 498.495 625.559 786.964"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 107.658,
    height: 15.183,
    x: 79.675,
    y: 720.023,
    fill: "#f2f2f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M219.17236,729.59145a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,219.17236,729.59145Zm0-22a10,10,0,1,0,10,10A10.01114,10.01114,0,0,0,219.17236,707.59145Z",
    transform: "translate(-83 -38.0783)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M923.65272,389.33528s6,23,8,24,24,20,9,23-26,2-29-1-2-6-7-7-14-4-13-11,6-26,9-28S923.65272,389.33528,923.65272,389.33528Z",
    transform: "translate(-83 -38.0783)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M836.65272,440.33528s9,7,4,20-12,27-12,27-8,25-21,21c-5.28125-1.625-7.92188-6.05567-9.19577-10.7442a25.6964,25.6964,0,0,1,3.63167-20.90966l7.5641-11.34614,8-21Z",
    transform: "translate(-83 -38.0783)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M814.70447,537.15071c17.92578,0,40.1045-5.93848,61.71778-27.40235C929.3324,457.19954,979.599,451.929,980.10047,451.88215L979.914,449.89c-.50879.04785-51.48829,5.39062-104.90186,58.43847-27.44629,27.25879-55.77539,28.92871-74.707,25.52735a93.3633,93.3633,0,0,1-34.999-14.10547l-1.18165,1.61328a95.44532,95.44532,0,0,0,35.74805,14.44629A83.49825,83.49825,0,0,0,814.70447,537.15071Z",
    transform: "translate(-83 -38.0783)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 870.153,
    cy: 443.757,
    r: 12,
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 785.153,
    cy: 499.757,
    r: 12,
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 773.006,
    cy: 78.116,
    r: 23.996,
    fill: "#a0616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M876.08153,38.0783a18.199,18.199,0,0,1-10.5008,7.2188c-7.343,1.96628-.06,13.00075-.06,13.00075s-2.64837-4.01254,1.17154-8.26192S876.65941,42.88135,876.08153,38.0783Z",
    transform: "translate(-83 -38.0783)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 781.219,
    cy: 22.867,
    r: 9.278,
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M876.06557,68.72172c-7.56395-2.861-20.15862-4.31161-26.63825-3.32l.88866-6.48892c6.22935,3.21953,18.76622,4.7325,26.63824,3.32Z",
    transform: "translate(-83 -38.0783)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M859.42931,76.04442s-9.47969,15.76794-31.52318,21.67067-.18006,39.028-.18006,39.028-7.95034-12.04555,3.51694-24.8021S861.16412,90.46307,859.42931,76.04442Z",
    transform: "translate(-83 -38.0783)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M860.18167,75.08626s9.10688,21.658,19.10482,23.70558,9.23961,36.26938-6.39559,41.40109c0,0,11.40091-20.06226,1.65574-33.51712S858.646,82.58471,860.18167,75.08626Z",
    transform: "translate(-83 -38.0783)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailArrived);
export default __webpack_public_path__ + "static/media/email_arrived.c47037ed.svg";
export { ForwardRef as ReactComponent };